export var CardTypes;
(function (CardTypes) {
    CardTypes["Problems"] = "Problems";
    CardTypes["History"] = "History";
    CardTypes["Labs"] = "Labs/Studies";
    CardTypes["Medications"] = "Medications";
    CardTypes["Vitals"] = "Vitals";
    CardTypes["Recommendations"] = "Clinical Recommendations";
})(CardTypes || (CardTypes = {}));
var ClearedRecommendation = /** @class */ (function () {
    function ClearedRecommendation(id, clearedInterval, title) {
        this.id = id;
        this.clearedInterval = clearedInterval;
        this.title = title;
    }
    return ClearedRecommendation;
}());
export { ClearedRecommendation };
export var clearedRecommendationIntervals = [
    { value: 0, label: '-- Select --' },
    { value: 3, label: '3 months' },
    { value: 6, label: '6 months' },
    { value: 12, label: '12 months' },
];
export var LabOrderState;
(function (LabOrderState) {
    LabOrderState[LabOrderState["NEW"] = 0] = "NEW";
    LabOrderState[LabOrderState["NOT_SENT"] = 1] = "NOT_SENT";
    LabOrderState[LabOrderState["INITIALIZED"] = 2] = "INITIALIZED";
    LabOrderState[LabOrderState["AWAITING_RESULTS"] = 3] = "AWAITING_RESULTS";
    LabOrderState[LabOrderState["PRELIM_RESULTS"] = 4] = "PRELIM_RESULTS";
    LabOrderState[LabOrderState["FINAL_RESULTS"] = 5] = "FINAL_RESULTS";
    LabOrderState[LabOrderState["CORRECTION_TO_RESULTS"] = 6] = "CORRECTION_TO_RESULTS";
    LabOrderState[LabOrderState["RESULTS_DELAYED"] = 7] = "RESULTS_DELAYED";
    LabOrderState[LabOrderState["CANCELLED"] = 8] = "CANCELLED";
    LabOrderState[LabOrderState["ERROR"] = 9] = "ERROR";
    LabOrderState[LabOrderState["SIGNED_OFF"] = 10] = "SIGNED_OFF";
    LabOrderState[LabOrderState["NOTIFY_REQUIRED"] = 11] = "NOTIFY_REQUIRED";
    LabOrderState[LabOrderState["PATIENT_NOTIFIED"] = 12] = "PATIENT_NOTIFIED";
    LabOrderState[LabOrderState["REVIEW_REQUIRED"] = 13] = "REVIEW_REQUIRED";
})(LabOrderState || (LabOrderState = {}));
export var labStatusDisplay = [
    'New',
    'Not Sent',
    'Initialized',
    'Needs Results',
    'Preliminary Results',
    'Result Ready',
    'Correction To Results',
    'Results Delayed',
    'Cancelled',
    'Error',
    'Signed',
    'Notification Required',
    'Patient Notified',
    'Review Required',
];
export var INVALID_ENTRY_ERROR = {
    title: 'Invalid Entry',
    message: 'We couldn’t find what you’re looking for. Check to see if you entered the information correctly and if the problem persists, please contact customer support.',
};
export var ACCESS_DENIED_ERROR = {
    title: 'Access Denied',
    message: 'You do not have permission to access this page. Please contact your System Administrator for support.',
};
export var ACCESS_CONTROL_ERROR = {
    title: 'Error Validating Permissions',
    message: 'We were unable to validate user permissions, please refresh the page and if the problem persists, please contact customer support.',
};
var HistoryDisplay = /** @class */ (function () {
    function HistoryDisplay(displayOrder, category, text) {
        this.displayOrder = displayOrder;
        this.category = category;
        this.text = text;
    }
    return HistoryDisplay;
}());
export { HistoryDisplay };
export var Status;
(function (Status) {
    Status["YES"] = "YES";
    Status["NO"] = "NO";
    Status["UNKNOWN"] = "UNKNOWN";
})(Status || (Status = {}));
export var HistorySectionTitle;
(function (HistorySectionTitle) {
    HistorySectionTitle["MEDICAL"] = "PMHx";
    HistorySectionTitle["SURGICAL"] = "PSHx";
    HistorySectionTitle["FAMILY"] = "FHx";
    HistorySectionTitle["SOCIAL"] = "SHx";
    HistorySectionTitle["OB_PREGNANCY"] = "OB & Pregnancy Hx";
    HistorySectionTitle["HOSPITALIZATION"] = "Hospitalizations / Procedures";
    HistorySectionTitle["LONG_TERM_CARE"] = "Long Term Care Facility";
    HistorySectionTitle["HOSPICE"] = "Hospice";
    HistorySectionTitle["DEVICES"] = "Implantable Devices";
})(HistorySectionTitle || (HistorySectionTitle = {}));
export var BLOOD_TYPE_HISTORY_FORM = 'Blood Type/RH Factor';
export var CONFIGURATION_ERROR = 'The customized view of your facesheet has failed to load. Please try again by refreshing the page.';
var HistoryDisplayUpdated = /** @class */ (function () {
    function HistoryDisplayUpdated(id, category, text) {
        this.id = id;
        this.category = category;
        this.text = text;
    }
    return HistoryDisplayUpdated;
}());
export { HistoryDisplayUpdated };
export var CACHED_DATA_TOOLTIP_MESSAGE = 'Information may be outdated. Refresh the page to view latest update';
export var CACHED_DATA_STATUS_CODE = 299;
export var DATE_CACHED_HTTP_HEADER = 'Tebra-Cache-Date';
export var APPOINTMENT_INFO_ERROR = 'Trouble retrieving appointment information';
